
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React, { ChangeEvent, useEffect, useState } from "react";
import { Button, Card, Container, Modal } from "react-bootstrap";
import { useAuth } from "../../../../contexts/AuthContext";
import { QueryListProvider } from "../../../../component/solution/QueryList/QueryListContext";
import { QueryList } from "../../../../component/solution/QueryList/QueryList";
import { Search, X } from "lucide-react";
import { CastType, IQuery, IWhere } from "../../../../component/solution/Interfaces";
import { formatDateFull } from "../../../../component/solution/utils/AppUtil";

enum MovementInStatus {
    TO_SEND = "TO_SEND",
    SENT = "SENT",
    SUCCESS = "SUCCESS", // M24L Validation Success
    ERROR = "ERROR", // M24L Validation Failed
    ARRIVED = "ARRIVED",
    CLOSED = "CLOSED"
}

export const StockMovementsIn: React.FC = () => {

    const {fetchData, token}  = useAuth();
    const [resultElements, setResultElements] = useState<React.ReactElement[]>([]);
    const [detailElements, setDetailElements] = useState<React.ReactElement[]>([]);
    const [search, setSearch] = useState<Map<string, string>>(new Map<string, string>());
    // Modal Show & Close
    const [showModal, setShowModal] = useState(false);
    const [docNo, setDocNo] = useState<number>(0);

    const queryUrl: string = `${process.env.REACT_APP_BASE_URL}/${"query/data"}`;
    const [queryState, setQueryState] = useState<IQuery>(
        {
            tableName: "sa_m24l_stock_movement_in",
            select: [
                {
                    fullColumnName: "doc_num",
                    aggregate: ""
                },
                {
                    fullColumnName: "card_code",
                    aggregate: ""
                },
                {
                    fullColumnName: "from_warehouse",
                    aggregate: ""
                },
                {
                    fullColumnName: "to_warehouse",
                    aggregate: ""
                },   
                {
                    fullColumnName: "card_name",
                    aggregate: ""
                },              
                {
                    fullColumnName: "integration_status",
                    aggregate: ""
                }, 
                {
                    fullColumnName: "total_qty",
                    aggregate: ""
                }, 
                {
                    fullColumnName: "comments",
                    aggregate: ""
                },                                                
                {
                    fullColumnName: "created",
                    aggregate: ""
                },
                {
                    fullColumnName: "updated",
                    aggregate: ""
                },
            ],
            groupBy: [],
            join: [],
            orderBy: [ 
                {
                    fullColumnName: "doc_num",
                    direction: "DESC",
                    cast: CastType.INTEGER
                }
            ],
            where: [
                // {
                //     fullColumnName: "updated",
                //     value: null,
                //     operator: "NE",
                //     cast: CastType.STRING
                // }
            ],
            mainTableOnly: false,
            includeExtraColumns: false,
            includeControlColumns: true,
            modifiedAfter: null,
            touchedBefore: null,
            isDirty: null,
            pageNum: 0,
            pageSize: 50,
            frontEndOnly: null
        }        
    );

    // useEffect(() => {
    //     fetchStockMovementsIn();       
    // }, [queryState]);

    // useEffect(() => {
    //     const searchFields = new Map<string, string>()
    //     searchFields.set("doc_num", "");
    //     searchFields.set("card_code", "");
    //     searchFields.set("from_warehouse", "");
    //     searchFields.set("to_warehouse", "");
    //     searchFields.set("card_name", "");
    //     searchFields.set("integration_status", "");
    //     searchFields.set("total_qty", "");
    //     searchFields.set("comments", "");
    //     setSearch(searchFields);        
    // }, []);



    // const processResult = (result: any) => {
    //     const shipments: any[] = result.data;
    
    //     // Build React elements and set state
    //     const resultElements: React.ReactElement[] = shipments.map((record, index) => (
    //         <tr id={record.data?.doc_num} onClick={() => fetchDocumentDetail(record.data?.doc_num)} key={index} className="record-line">
    //             <td>{record.data?.doc_num}</td>
    //             <td>{record.data?.card_code}</td>
    //             <td>{record.data?.from_warehouse}</td>
    //             <td>{record.data?.to_warehouse}</td>
    //             <td>{record.data?.card_name}</td>
    //             <td className="bg-success text-dark text-center">{record.data?.integration_status}</td>
    //             <td>{record.data?.total_qty}</td>
    //             <td>{record.data?.comments}</td>
    //             <td style={{whiteSpace: "nowrap"}}>{formatDateFull(record.control?.created)}</td>
    //             <td style={{whiteSpace: "nowrap"}}>{formatDateFull(record.control?.updated)}</td>
    //         </tr>
    //     ));

    //     setResultElements(resultElements);
    // }

    // const fetchStockMovementsIn = () => {
    //     fetchData(queryUrl, {method:"POST", body: JSON.stringify(queryState)}, processResult);        
    // }

    // const searchClicked = () => {
    //     let where: IWhere[] = [];

    //     search.forEach((value: string, column: string) => {
    //         console.log(column + " : " + value);
    //         if(value && value.length){
    //             const clause: IWhere = {
    //                 fullColumnName: column,
    //                 value: '%' + value + '%',
    //                 operator: "LIKE",
    //                 cast: CastType.STRING
    //             }
    //             where.push(clause);
    //         }
    //     });    

    //     const query = {...queryState}
    //     query.where = where;
    //     query.pageNum = 0;
    //     setQueryState(query);
    //     console.log(query);
    // }

    // const clearClicked = () => {

    //     const search = new Map<string, string>()
    //     search.set("doc_num", "");
    //     search.set("card_code", "");
    //     search.set("from_warehouse", "");
    //     search.set("to_warehouse", "");
    //     search.set("card_name", "");
    //     search.set("integration_status", "");
    //     search.set("total_qty", "");
    //     search.set("comments", "");
    //     setSearch(search);

    //     let where: IWhere[] = [];

    //     search.forEach((value: string, column: string) => {
    //         console.log(column + " : " + value);
    //         if(value && value.length){
    //             const clause: IWhere = {
    //                 fullColumnName: column,
    //                 value: '%' + value + '%',
    //                 operator: "LIKE",
    //                 cast: CastType.STRING
    //             }
    //             where.push(clause);
    //         }
    //     });  

    //     const query = {...queryState}
    //     query.where = where;
    //     setQueryState(query);      
    // }
    
    // const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    //     if(event.target.type === 'text') {
    //         setSearch(prevSearch => {
    //             const newSearch = new Map(prevSearch);
    //             newSearch.set(event.target.id, event.target.value);
    //             return newSearch;
    //         });
    //     }
    // }    

    // const fetchDocumentDetail = async (docNo: number) => {
        
    //     setDocNo(docNo);

        const detailQueryState: IQuery = {
            tableName: "sa_m24l_stock_movement_in_line",
            select: [
            ],
            groupBy: [],
            join: [],
            orderBy: [
                {
                    fullColumnName: "line_num",
                    direction: "ASC",
                    cast: CastType.NUMERIC
                }
            ],
            where: [
                {
                    fullColumnName: "doc_num",
                    value: "",
                    operator: "EQ",
                    cast: CastType.STRING
                }
            ],
            mainTableOnly: false,
            includeExtraColumns: false,
            includeControlColumns: true,
            modifiedAfter: null,
            touchedBefore: null,
            isDirty: null,
            pageNum: 0,
            pageSize: 5000,
            frontEndOnly: null
        }


    const generateDetailTables = (detail: any[]) => {

        const detailTable: React.ReactElement[] = [];
        let totalQuantityOrdered = 0;
        let totalQuantityRecieved = 0;

        // Sort by line_num ascending before rendering
        const sortedDetail = [...detail].sort((a, b) => {
            const aLine = a.data?.line_num ?? 0;
            const bLine = b.data?.line_num ?? 0;
            return aLine - bLine;
        });

        sortedDetail.forEach((item, idx) => {
            const data = item.data;
            totalQuantityOrdered += data?.qty_ordered ?? 0;
            totalQuantityRecieved += data?.qty_received ?? 0;

            detailTable.push(
            <tr key={idx}>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.line_num}</td>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.item_code}</td>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.handling_unit}</td>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.qty_ordered}</td>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.qty_received}</td>
            </tr>
            );
        });

        const summaryTable = (
            <table className="table w-auto" style={{ border: '1px solid #adb5bd' }}>
            <tbody>
                <tr>
                    <th style={{ width: '150px', border: '1px solid #adb5bd' }}>Unique Item Total</th>
                    <td style={{ width: '100px',  border: '1px solid #adb5bd' }} className="text-end">{detail.length}</td>
                </tr>
                 <tr>
                    <th style={{ width: '150px', border: '1px solid #adb5bd' }}>Total Qty Ordered</th>
                    <td style={{ width: '100px',  border: '1px solid #adb5bd' }} className="text-end">{totalQuantityOrdered}</td>
                </tr>
                <tr>
                    <th style={{ width: '150px', border: '1px solid #adb5bd' }}>Total Qty Recieved</th>
                    <td style={{ width: '100px',  border: '1px solid #adb5bd' }} className="text-end">{totalQuantityRecieved}</td>
                </tr>
            </tbody>
        </table>
        );

        return { summaryTable, detailTable };
    };

    /*
    Status 

    Inbound - Retail Returns
    TO_SEND - Document ready to be sent to M24L.
    SENT - Doument has has been sent to M24L for processing.
    SUCCESS - document successfully received at M24L for processing.
    ERROR - There was a problem integrating the document at M24L.
    ARRIVED - Shipment has arrived at M24L.
    CLOSED - Document processing complete.

    */

    return(
        <React.Fragment>
            <Container fluid className="p-0">

            <QueryListProvider>
                    <QueryList
                        listTitle={"Inbound - Retail Returns"}
                        recordTitle={"Inbound - Retail Returns"}
                        tableName={"sa_m24l_stock_movement_in"}
                        editTableName={"sa_m24l_stock_movement_in"}
                        hasIntegrationStatusLegend={true}
                        errorCategoryName={'MovementIn'}
                        integrationstatusLegend={[
                            { status: 'ERROR', color: '#bf3636', description: 'There was a problem integrating the document at M24L.'},
                            { status: 'TO_SEND', color: '#d4a53f', description: 'Document ready to be sent to M24L.'},
                            { status: 'ARRIVED', color: '#d4a53f', description: 'Shipment has arrived at M24L.'},
                            { status: 'SENT', color: '#d4a53f', description: 'Doument has has been sent to M24L for processing.'},
                            { status: 'SUCCESS', color: '#d4a53f', description: 'Document successfully received at M24L for processing.'},
                            { status: 'CLOSED', color: '#3ec76b', description: 'Document processing complete.'}
                        ]}
                        modal={
                            {
                              modalTitle: "Doc Num:",
                              modalSubtitle: "Inbound - Retail Return:",
                              modalProptBy: "doc_num",
                              tableName: "sa_m24l_stock_movement_in",
                              tableLineQuery: "sa_m24l_stock_movement_in_line",
                              modalAction: 'viewing',
                              modalHasViewing: true,
                              queryData: detailQueryState,
                              processData: (result: any) : JSX.Element => {
                                 
                                const detail: any[] = result.data;
                                const { summaryTable, detailTable } = generateDetailTables(detail);

                                return (
                                      <div className="d-flex flex-column gap-3" >
                                        <div style={{background:"#f2f5f3"}} className="p-2">
                                            <h6 className="text-secondary fw-bolder">
                                               Summary
                                            </h6>
                                            <div className="mb-3">{summaryTable}</div>
                                        </div>

                                        <div style={{background:"#f2f5f3"}} className="p-2">
                                            <h6 className="text-secondary fw-bolder">
                                                Line Details
                                            </h6>
                                            <table className="table" style={{ border: '1px solid #adb5bd' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ border: '1px solid #adb5bd' }}>Line No.</th>
                                                        <th style={{ border: '1px solid #adb5bd' }}>Item Code</th>
                                                        <th style={{ border: '1px solid #adb5bd' }}>Handling Unit</th>
                                                        <th style={{ border: '1px solid #adb5bd' }}>Qty Ordered</th>
                                                        <th style={{ border: '1px solid #adb5bd' }}>Qty Recieved</th>
                                                    </tr>
                                                </thead>
                                                <tbody>{detailTable}</tbody>
                                            </table>
                                        </div>
                                    </div>
                                 )
                               }
                            }
                        }
                        editHasCompoundKey={false}
                        join={[{
                            relationship: "notifications",
                            joinType: "LEFT"
                        }]} 
                        select={[
                            {
                                fullColumnName: "doc_num",
                                aggregate: ""
                            },  
                            {
                                fullColumnName: "division",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "card_code",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "card_name",
                                aggregate: ""
                            },   
                            {
                                fullColumnName: "num_at_card",
                                aggregate: ""
                            }, 
                            {
                                fullColumnName: "from_warehouse",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "to_warehouse",
                                aggregate: ""
                            },            
                            {
                                fullColumnName: "integration_status",
                                aggregate: ""
                            }, 
                            {
                                fullColumnName: "total_qty",
                                aggregate: ""
                            }, 
                            {
                                fullColumnName: "comments",
                                aggregate: ""
                            },                                                
                            {
                                fullColumnName: "created",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "updated",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "notifications.reference",
                                aggregate: "COUNT"
                            },
                        ]}
                        where={[]} 
                        orderBy={[    
                            {
                                fullColumnName: "doc_num",
                                direction: "DESC",
                                cast: CastType.INTEGER
                            }
                         ]} 
                        groupBy={[
                            "doc_num",
                            "division",
                            "card_code",
                            "card_name",
                            "num_at_card",
                            "from_warehouse",
                            "to_warehouse",
                            "integration_status",
                            "total_qty",
                            "comments",
                            "created",
                            "updated"
                        ]}                   
                    />
                </QueryListProvider>
            </Container>
        </React.Fragment>
    );
}